export const PRINT_TEMPLATE_IDS = Object.freeze({
  NOR: "nor",
  SOF: "sof",
  OBQ_ROB: "obq-rob",
  RCS: "rcs",
  PUMP_STATEMENT: "pump-statement",
  LOG: "log",
  CTC: "ctc",
  ETC: "etc",
  DEADWEIGHT: "deadweight",
  SLOP: "slop",
  PROTEST: "protest",
  CHECKLIST: "checklist",
  VEF: "vef",
  PERMITS: "permits",
  PIPE_TRUNK_ENTRY: "pipe-trunk-entry",
});
